class cAvatar {
    constructor(selector) {
        if (!selector) return;

        this.body = document.querySelector("body");
        this.html = document.querySelector("html");
        this.container = document.querySelector(selector);
        if ( this.container === null ){
          return;  
        }
        this.overlay = this.container.querySelector(".c-avatar-menu-overlay");
        this.dropdown = this.container.querySelector(".c-avatar-menu-container");
        this.icon = this.container.querySelector(".c-avatar-dropdown > i");
        this.closeBtn = this.container.querySelector(".c-close-header-section");

        this.init();
    }

    init() {
        this.closeBtn.addEventListener("click", () => this.hide());
        this.overlay.addEventListener("click", () => this.hide());
        this.container.addEventListener("click", (e) => this.toggle(e));
        this.dropdown.addEventListener("click", (e) => e.stopPropagation());

        document.addEventListener("click", (e) => this.handleOutsideClick(e));
    }

    show() {
        if ( typeof window.languageDropdownMenu === 'object' ){
            window.languageDropdownMenu.hide();
        }
        this.overlay.classList.add("show");
        if (window.innerWidth > 1025) {
            this.dropdown.classList.add("show");
        }else{
            setTimeout(() => this.dropdown.classList.add("show"), 100);
        }

        this.icon.classList.add("fa-chevron-up");
        this.icon.classList.remove("fa-chevron-down");

        if (window.innerWidth < 1024) {
            this.body.classList.add("body-no-scroll");
            this.html.classList.add("html-modal-open");
            this.overlay.classList.add("overlay-show");
        }

        if ( typeof window.searchBoxDesktop === 'object' ){
            window.searchBoxDesktop.hide();
        }
    }

    hide() {
        if (!this.overlay.classList.contains("show")) return;

        this.dropdown.classList.remove("show");
        if (window.innerWidth > 1025) {
            this.overlay.classList.remove("show")
        }else{
            setTimeout(() => this.overlay.classList.remove("show"), 250);
        }        

        this.icon.classList.remove("fa-chevron-up");
        this.icon.classList.add("fa-chevron-down");

        if (window.innerWidth < 1024) {
            this.body.classList.remove("body-no-scroll");
            this.html.classList.remove("html-modal-open");
        }
        this.overlay.classList.remove("overlay-show");
    }

    toggle(event) {
        event.stopPropagation();
        if (this.overlay.classList.contains("show")) {
            this.hide();
        } else {
            this.show();
        }
    }

    handleOutsideClick(event) {
        if (window.innerWidth > 1025) {
            if (!this.container.contains(event.target) && this.overlay.classList.contains("show")) {
                this.hide();
            }
        }
    }
}
